import ReviewRating from './ReviewRatingContainer';

export default ReviewRating;
